import { IEFamilyIddMatchParam, IEUserIdMatchParam } from './@types';

const URL_BASE = '/users';
const URL_UPDATE = `${URL_BASE}/${IEUserIdMatchParam.PATTERN}`;
const URL_GET_USER = `${URL_BASE}/${IEUserIdMatchParam.PATTERN}`;
const URL_SET_ALIAS = `${URL_BASE}/${IEUserIdMatchParam.PATTERN}/set_alias`;
const URL_VERIFY_EMAIL_AVAILABILITY = `${URL_BASE}/email_availability`;
const URL_GET_USER_ACCOUNT = `/accounts/${IEFamilyIddMatchParam.PATTERN}/plans`;

export default URL_BASE;
export { URL_UPDATE, URL_SET_ALIAS, URL_GET_USER, URL_VERIFY_EMAIL_AVAILABILITY, URL_GET_USER_ACCOUNT };
